import { Component, OnInit, SimpleChanges, Input, EventEmitter, Output } from '@angular/core';
import { config } from '../../config';
import { ActivatedRoute, Router } from '@angular/router';
import { FileService } from '../../services/file.service';
import { FolderService } from 'src/app/services/folder.service';
import { UtilityService } from '../../services/utility.service';
import { SharedService } from 'src/app/shared.service';
@Component({
  selector: 'app-video-preview',
  templateUrl: './video-preview.component.html',
  styleUrls: ['./video-preview.component.scss']
})
export class VideoPreviewComponent implements OnInit {
  @Input('viewPath') path;
  @Input('file') fileId;
  @Input('extension') fileExtension
  @Input('singleFile') fileDetails
  @Output() markAsReadFile: EventEmitter<any> = new EventEmitter<any>();
  displayPath
  displayId
  videoPath
  displayVideo = false
  displayPreview = false
  loading = false
  audioFlag = false
  extensionFile
  singleFileDetails
  user = JSON.parse(localStorage.getItem('userRoles'))
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public fileService: FileService,
    public _folderService: FolderService,
    public _utilityService: UtilityService,
    public _sharedService: SharedService
  ) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(qparams => {
      console.log("what is the query params value", qparams);
      // this.displayPath = qparams.path
      let fileId = qparams.path
      this.getSingleFile(fileId)
      // this.displayPath = localStorage.getItem('path')
      // console.log("final path to displaay", this.displayPath);

    })

  }



  ngOnChanges(changes: SimpleChanges): void {
    console.log("when video is clickble", changes);
    if (changes.path && changes.path.currentValue) {
      this.displayPath = changes.path.currentValue
      this.displayPreview = true
    } else {
      this.displayPreview = false
    }
    if (changes.fileId && changes.fileId.currentValue) {
      this.displayId = changes.fileId.currentValue
    }
    if (changes.fileExtension && changes.fileExtension.currentValue) {
      this.extensionFile = changes.fileExtension.currentValue
    }
    if (changes.fileDetails && changes.fileDetails.currentValue) {
      this.singleFileDetails = changes.fileDetails.currentValue
    }
  }




  openVideo() {
    console.log("when click on video", this.displayPath, this.singleFileDetails, this.user);
    let data = config.baseApiUrl
    let vivek = "123456789"
    if ((this.user && this.user.isOperative) && (this.singleFileDetails.status && this.singleFileDetails.status.isRead == false)) {
      this._folderService.markAsRead([this.singleFileDetails._id]).subscribe((res) => {
        // this._utilityService.handleSnackBar({ msg: 'Files marked as read', button: 'OK' })
        // this..markAsReadFile.emit(res)
        this._sharedService.markasReadFile({ list: [this.singleFileDetails._id], type: 'file' })

      })
    }
    // localStorage.setItem('path', this.displayPath)
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/video-preview/${this.displayId}`])
    );
    console.log("this url is ready to open", url);

    // console.log("what is current path", data)
    // let link = this.displayPath
    window.open(url, "_blank");
  }


  // API CALL


  getSingleFile(fileId) {
    console.log("what is file id", fileId);
    if (fileId != undefined) {
      this.loading = true
      this.fileService.getSingleFile(fileId).subscribe((response) => {
        console.log("respoonse of single file details", response);
        let singleImage = response.response
        if (singleImage.extension == 'mp4' || singleImage.extension == 'mov') {
          this.videoPath = singleImage.path
          this.displayVideo = true
          this.displayPreview = false
          this.loading = false
        } else {
          console.log("this is download url");
          // this.videoPath = singleImage.path
          // this.audioFlag = true
          this.downloadVideo(singleImage.path, singleImage.alias)
        }
      }, error => {
        console.log("error while get single fiiile details", error);
        this.loading = false
      })
    }
  }

  downloadVideo(path, name) {
    const download = document.createElement("a")
    const fileName = name
    download.href = path
    download.download = fileName
    download.click()
    setTimeout(() => {
      window.close()
      this.loading = false
    }, 1000)
  }

}
